export default function RestoreButton({ askForResetNextSalaryDate }) {
  return (
    <button
      className="btn btn-dark btn-hover-white shadow mb-1"
      onClick={askForResetNextSalaryDate}
    >
      Återställ
    </button>
  );
}
